import React from 'react';
import c from 'classnames';
import type Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import type { NodeActivity } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewActivitiesOverviewBuurtboerderijProps {
  entities: Immutable.List<ImmutableEntity<NodeActivity>>;
}

// eslint-disable-next-line max-len
const ViewActivitiesOverviewBuurtboerderij: React.FC<ViewActivitiesOverviewBuurtboerderijProps> = ({ entities }) => {
  const classNames = c('View', 'View--ActivitiesOverviewBuurtboerderij');

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          {entities.map((entity) => {
            const node = entity.toJS();
            const id = node.nid[0].value;
            const uuid = node.uuid[0].value;
            const langcode = node.langcode[0].value;

            return (
              <div key={`${uuid}:${langcode}`} className="col-12 col-md-6 col-lg-4">
                <Node
                  id={id}
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ViewActivitiesOverviewBuurtboerderij;
